const Colors = {
    LOW: '#44B764',
    MEDIUM: '#DC7C24',
    HIGH: '#F94444',
    "To do": '#F94444',
    Progress: '#DC7C24',
    Hold:'#595047',
    Completed:'#44B764',
    Accounts:'#009DB2',
    Design:'#FF820E',
    Production:'#B3006B',

};

export default Colors;